import React from "react"
import { IncidentContext } from "../../context"
import { IncidentListItem, ArchivedIncidentItem } from "../../utils/form-field-mapping"

type TProps = {
  children: React.ReactNode
}

const IncidentProvider = (props: TProps) => {
  const [incidents, setIncidents] = React.useState<undefined | IncidentListItem[]>(undefined)
  const [archivedIncidents, setArchivedIncidents] = React.useState<undefined | ArchivedIncidentItem[]>(undefined)

  return (
    <React.Fragment>
      <IncidentContext.Provider
        value={{
          incidents,
          setIncidents,
          archivedIncidents,
          setArchivedIncidents,
        }}
      >
        {props.children}
      </IncidentContext.Provider>
    </React.Fragment>
  )
}

export default IncidentProvider
